import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import ScreenUtils from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ChannelFilterTitle = styled.span<{ focused?: boolean }>`
  color: ${Colors['light']};
  font-family: ${Fonts['regular']};
  font-size: ${32 * ScreenUtils.widthRatio}px;
  line-height: ${40 * ScreenUtils.widthRatio}px;
  margin-right: ${12 * ScreenUtils.widthRatio}px;
  opacity: ${(props) => (props.focused ? '1' : '0.5')};
`;
export default ChannelFilterTitle;
